import { useSelector } from "react-redux";
import { generatePath, useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import logo from "../../assets/img/logo-Photoroom.png";
import logo from "../../assets/img/hlogo.png";
import userIcon from "../../assets/img/UserImage.png";
import navbarimg from "../../assets/img/navbarblack.png";
import { logoutUser } from "../../store/slices/UserSlice";
import { Persona, PersonaSize } from "@fluentui/react";
import http from "../../api/server";
import { GET_USER_PROFILEDETAILS } from "../../api/apiPath";
import { hostName } from "../../config/config";
import { useEffect, useState } from "react";


const Header = (props) => {
  const { clientNameParam } = useParams();
  // redux state
  const { userObj } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
const [profileImage, setProfileImage] = useState(null);

const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  // const personaProps = {
  //   imageUrl: userObj?.imageUrl ? userObj?.imageUrl : userIcon, // Replace with your image URL
  //   // text: userObj?.userName, // User's name
  //   //secondaryText: 'john.doe@example.com', // User's email
  // };
  const personaProps = {
  imageUrl: profileImage || userIcon,
};


  // dispatch and navigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //  ADDED: robust client param validity check (handles undefined, null, empty, "null", "undefined")
  const isClientValid =
    typeof clientNameParam === "string" &&
    clientNameParam.trim() !== "" &&
    clientNameParam !== null &&
    clientNameParam !== undefined;



      useEffect(() => {
  if (!userObj?.userId) return;

  const fetchProfileImage = async () => {
    try {
      const response = await http.get(GET_USER_PROFILEDETAILS, {
        params: {
          clientId: userObj?.clientId, // if available
          userId: userObj?.userId,
        },
      });

      if (response.status === 200 && response.data?.profileImage) {
        setProfileImage(
          ImageProxyBaseUrl + encodeURIComponent(response.data.profileImage)
        );
      }
    } catch (err) {
      console.error("Failed to load profile image", err);
    }
  };

  fetchProfileImage();
}, [userObj?.userId]);

  //  ADDED: Only redirect if userObj is missing AND we have a valid client param
  if (!userObj && isClientValid) {
    window.location.href = generatePath("/client/:clientNameParam/", {
      clientNameParam,
    });
    return;
  }

  const hideSideBar = () => {
    // eslint-disable-next-line react/prop-types
    props.setHideSidebar(!props.hideSidebar);
  };
  const gotoprofile = () => {
    // setOpen(false);
    navigate(
              generatePath("/client/:clientNameParam/UserProfile", {
                clientNameParam,
              })
            )
  }



  return (
    <nav className="navbar navbar-expand-lg bg-light border-bottom dashboard_nav p-0 px-2 pe-0">
        <div
          className="d-flex align-items-center header-gap"
          style={{
            backgroundColor: "white",
            height: "68px",
            position: "fixed",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
            left:"0",
            right:"0",
            top:"0",
          }}
        >
          <button
            className="navbarMenuBtn"
            id="navbarNav"
            onClick={() => {
              hideSideBar();
            }}
            style={{ marginLeft: "10px" }}
          >
            {/* <span className="navbar-toggler-icon"></span> */}
            <img src={navbarimg} className="navbar-toggler-icon" alt="logo" />
          </button>
          <a
            className="navbar-brand ps-4"
            href={
              isClientValid
                ? generatePath("/client/:clientNameParam/property-form", {
                    clientNameParam,
                  })
                : "#" /*  ADDED: safe href fallback if invalid */
            }
          >
            <img src={logo} className="logoheader " alt="logo" />

            {isClientValid ? (
              <>
                <p
                  className="mt-4 ps-2"
                  style={{ fontSize: "14px", fontWeight: "500" }}
                >
                  Hello, {userObj?.userName}
                </p>
              </>
            ) : null}
          </a>

          <div className="d-flex align-items-end gap-2 ms-auto top_nav_right">
            <div className="d-flex flex-row gap-2 align-items-center">
              {/* <div className="search_bar">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  type="text"
                  className="form-control"
                  id="floatingInput"
                  placeholder="search"
                />
              </div> */}
              {/* <i className="fa-solid fa-gear"></i>
              <i className="fa-solid fa-bell"></i> */}

              {/* ADDED: Only show Persona and logout if clientNameParam is valid */}
              {isClientValid ? (
                <>
                  <div style={{ marginTop: "5px", cursor: "pointer" }}>
                    <Persona
                      {...personaProps}
                      size={PersonaSize.size32} // Adjust size as needed
                      imageAlt="User profile picture"
                      onClick={() => setOpen((prev) => !prev)}
                    />
                  </div>
                  {open && (
                    <div className="profile-dropdown me-4 mt-2">
                      <div className="profile-header ms-4">
                        <span className="profile-icon ms-2">
                          {" "}
                          <img
                            src={logo}
                            className="logoheader "
                            alt="logo"
                          />
                        </span>
                        <span className="ms-0">
                          Hello, {userObj?.userName}
                        </span>
                      </div>

                      <div className="profile-divider " />

                      <div className="profile-item text-start ms-2 mt-2"
                        onClick={() => gotoprofile()}
                      >
                        View Profile
                      </div>
                      <div
                        className="profile-item logout  text-start mt-1 ms-2"
                        onClick={() =>
                          dispatch(
                            logoutUser({
                              userId: userObj?.userId,
                              userIdentifier: userObj?.userEmail,
                            })
                          )
                        }
                      >
                        Log out
                      </div>
                    </div>
                  )}

                  {/* <i
                    className="fa-solid fa-right-from-bracket mt-2"
                    title="Logout"
                    style={{cursor:"pointer"}}
                    onClick={() =>
                      dispatch(
                        logoutUser({
                          userId: userObj?.userId,
                          userIdentifier: userObj?.userEmail,
                        })
                      )
                    }
                  ></i> */}
                </>
              ) : null}

              {/* <button type="button" onClick={() => dispatch(clearUser())}>
                  LOGOUT
                </button> */}
            </div>
          </div>
        </div>
    </nav>
  );
};
export default Header;
